import { render, staticRenderFns } from "./TablaDivisas.vue?vue&type=template&id=365fb6eb"
import script from "./TablaDivisas.vue?vue&type=script&lang=js"
export * from "./TablaDivisas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports